import React, { useState } from "react";
import { Box, Button, Grid, Typography, TextField,Modal, useMediaQuery, useTheme } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";

const PreviewPublish = ({ handleBack, steps, formData, availabilityDays, promotionDays, availabilityCost, promotionCost }) => {
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
const [modalTitle, setModalTitle] = useState("");


  const handleNext = async () => {
    try {
      setLoading(true);
  
      const userEmail = sessionStorage.getItem("userEmail");
      const token = localStorage.getItem("token");
  
      if (!userEmail || !token) {
        console.error("User email or token missing.");
        alert("Authentication error. Please log in.");
        return;
      }
  
      const requestBody = {
        userEmail,
        productDetails: {
          categoryId: formData.categoryId,
          title: formData.title,
          description: formData.description,
          location: formData.location,
          price: formData.price,
        },
        imageVideos: {
          images: Array.isArray(formData.images) ? formData.images : [],
          videoFile: formData.videos?.[0] || "",
          videoUrl: formData.videoUrl || "",
        },
        p2PAvailabilty: {
          noOfDays: formData.availability?.noOfDays ?? 0,
          cost: formData.availability?.cost ?? 0,
        },
        p2PPromotion: {
          setPromo: formData.promotion?.enabled ?? false,
          promotionCost: formData.promotion?.enabled ? (formData.promotion?.days ?? 0) * 500 : 0,
          promotionDuration: formData.promotion?.days ?? 0,
        },
      };
  
      const response = await fetch(
        "https://daradservice.azurewebsites.net/api/P2PProducts/publish-product",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        }
      );
  
      const responseData = await response.json();
      console.log("Response Data:", responseData);
      
      // Always show modal with response message
      setModalTitle(responseData.status ? "Product Submitted Successfully!" : "Submission Failed");
      setModalMessage(responseData.message || "Something went wrong.");
      setOpenModal(true);
      
      // Only redirect on success
      if (response.ok && responseData.status) {
        setTimeout(() => {
          setOpenModal(false);
          navigate("/product/ptwop");
        }, 3000);
      }
      
  
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to submit product. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  

 

  


  
  return (
    <Box sx={{ maxWidth: 1200, mx: "auto", p: 3 }}>
   <Box sx={{ p: 4, maxWidth: 1200, mx: "auto", borderRadius: 2, boxShadow: 3, bgcolor: "white" }}>
   <Box sx={{  mb: 6 , borderBottom: "1px solid #ddd",}}>
      {/* Title */}
     <Typography variant="h4" align="center" color="#5604F6" mb="14px" fontWeight={600}sx={{
          fontSize: isDesktop ? "48px" : "36px", 
          ...theme.typography.urbanist800
        }}>
        Preview And Publish
      </Typography>
     <Typography 
             sx={{ ...theme.typography.Inter700,    fontSize: isDesktop ? "16px" : "18px", }} mb={3} color="#000000" textAlign="center">
        Check all the details before submitting. You can go back to make changes.
      </Typography>
</Box>
      {/* First Section: Image & Form */}
    
        {/* Left - Image Section */}
        <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
        {formData.videos && formData.videos.length > 0 ? (
    <Box sx={{ borderRadius: 4, overflow: "hidden" }}>
      <video
src={formData.videos[0]} type="video/mp4"
        controls
        autoPlay
        style={{ width: "100%", height: "300px", objectFit: "cover" }}
      />
    </Box>
  ) : formData.images && formData.images.length > 0 ? (
    formData.images.map((image, index) => (
      <Box
        key={index}
        component="img"
        src={image}
        alt={`Uploaded ${index + 1}`}
        sx={{ width: "100%", height: "300px", objectFit: "cover", borderRadius: 2 }}
      />
    ))
  ) : (
    <Typography>No Media Uploaded</Typography>
  )}

  {/* Display image thumbnails */}
  <Box display="flex" justifyContent="space-between" gap={1} mt={2} flexWrap="wrap">
    {Array.isArray(formData.images) &&
      formData.images.map((image, index) => (
        <Box key={index} sx={{ width: 60, height: 60, borderRadius: 1, overflow: "hidden" }}>
          <img
            src={image} // Using formData.images directly
            alt={`Thumbnail-${index}`}
            style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "5px" }}
          />
        </Box>
      ))}
  </Box>
</Grid>





 <Grid item xs={12} md={6}>
        <Typography  sx={{ ...theme.typography.urbanist800, fontSize: "16px", mt: 2 , mb:2 }}>Category</Typography>
  <TextField   fullWidth value={formData.categoryName} disabled  sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
            
            fontSize: isDesktop ? 18 : 16
          },
         "& .MuiInputBase-input": {
    color: "#000000", 
   
    fontSize: isDesktop ? 14 : 18
  },
        }} />

<Typography  sx={{ ...theme.typography.urbanist800, fontSize: "16px", mt: 2 ,mb:2}}>Product Title</Typography>
  <TextField fullWidth sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
       
            fontSize: isDesktop ? 18 : 16
          },
         "& .MuiInputBase-input": {
    color: "#000000", 
   
    fontSize: isDesktop ? 14 : 18
  },
        }} value={formData.title} disabled />

 <Typography  sx={{ ...theme.typography.urbanist800, fontSize: "16px", mt: 2 }}>Description</Typography>
  <TextField

 multiline fullWidth rows={4} margin="normal" value={formData.description} disabled  variant="outlined" sx={{
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: "#fff",
   
    fontSize: isDesktop ? 18 : 16
  },
}}/>
   
</Grid>

      </Grid>
      {/* {successMessage && <p className="text-green-600 text-center">{successMessage}</p>} */}

     
{/* Second Section: Price & Availability */}
<Grid container spacing={3} >
  {/* Left Section: Price & Location */}
  <Grid item xs={12} md={6}>
  <Typography  sx={{ ...theme.typography.urbanist800, fontSize: "16px", mt: 2, mb:2 }}>Price</Typography>
    <TextField fullWidth value={`₦ ${formData.price}`} disabled sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
            
            fontSize: isDesktop ? 18 : 16
          },
         "& .MuiInputBase-input": {
    color: "#000000", 
   
    fontSize: isDesktop ? 14 : 18
  },
        }} />

    <Typography  sx={{ ...theme.typography.urbanist800, fontSize: "16px", mt: 2 }}>Location</Typography>
    <TextField fullWidth  value={formData.location} disabled  sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
           
            fontSize: isDesktop ? 18 : 16
          },
          "& .MuiInputBase-input::placeholder": {
            color: "#A0A0A0",
          
            fontSize: isDesktop ? 14 : 18
          },
        }}/>
  </Grid>

  {/* Right Section: Availability & Promotion Duration */}
  <Grid item xs={12} md={6}>
  <Typography  sx={{ ...theme.typography.urbanist800, fontSize: "16px", mt: 2 }}>Availability Duration</Typography>

    <TextField fullWidth value={`${formData.availability.noOfDays} Days`} disabled  sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
            fontSize: isDesktop ? 18 : 16
          },
          "& .MuiInputBase-input::placeholder": {
            color: "#A0A0A0",
           
            fontSize: isDesktop ? 14 : 18
          },
        }} />
    
    <Typography  sx={{ ...theme.typography.urbanist800, fontSize: "16px", mt: 2 }}>Promotion Duration</Typography>
    
    <TextField fullWidth sx={{
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
   
      fontSize: isDesktop ? 18 : 16
    },
    "& .MuiOutlinedInput-input::placeholder": {
    
      color: "#A0A0A0",
      fontSize: isDesktop ? 14 : 18
      
    },
  }} value={`${formData.promotion.duration} Days`} disabled />

  </Grid>
</Grid>


      {/* Third Section: Buttons */}
      <Box sx={{ display: "flex", justifyContent:"center", flexDirection: isDesktop ? "row" : "column", mt: 3, width: "100%", gap: 2 }}>
      <Button
 sx={{
  width: isDesktop ? "40%" : "100%",
  padding: "10px 20px", 
  borderRadius: "25px", 
  backgroundColor: "#EEE6FE  !important",
  color: "#5604F6!important",
  textTransform: "none",

  fontSize: isDesktop ? "16px" : "18px",
  "&:hover": { backgroundColor: "#B0B0B0" },
          }}
               onClick={handleBack}
              
             >
               {"< Back to step 4"}
             </Button>
             <Button
    variant="contained"
    sx={{
      width: isDesktop ? "40%" : "100%", 
      padding: "10px 20px", 
      borderRadius: "25px",
      backgroundColor: "#5604F6 !important",
      color: "#EEE6FE !important",
 
      fontSize: 14,
      "&:hover": { backgroundColor: "#4b00c2" },
    }}
    onClick={handleNext}
    disabled={loading} 
  >
    {loading ? <CircularProgress size={24} sx={{ color: "#EEE6FE" }} /> : "Publish Product"}
  </Button>
      </Box>
    </Box>

  {/* Success Modal */}
  <Modal open={openModal} onClose={() => setOpenModal(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "white",
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
      textAlign: "center"
    }}
  >
    <Typography variant="h2" color="#5604F6" fontSize="20px">
      {modalTitle}
    </Typography>
    <Typography sx={{ mt: 2 }}>{modalMessage}</Typography>
    {modalTitle === "Product Submitted Successfully!" && (
      <Typography sx={{ mt: 1 }} fontSize="14px">
        Redirecting to Marketplace...
      </Typography>
    )}
  </Box>
</Modal>

     
    </Box>
  );
};

export default PreviewPublish;
